import React, { useState, useContext, useEffect } from 'react';
import './MyProjects.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise/dist/styles/ag-grid.css';
import 'ag-grid-enterprise/dist/styles/ag-theme-balham.css';
import 'ag-grid-enterprise';
import MilestonesDialog from './components/MilestonesDialog.js';
import LogsDialog from './components/LogsDialog.js';
import BudgetSessionsDialog from './components/BudgetSessionsDialog.js';
import Views from './components/Views.js';
import CustomPinnedRowRenderer from './components/CustomPinnedRowRenderer';
import { MyProjectsContext, MyProjectsProvider } from './MyProjectsContext';
import { UserContext, UserProvider, NavContext, NavRoutes, ToastContext } from './../../contexts';
import { Button } from '@material-ui/core';
import * as moment from "moment";
import { ApplicationRoles, ProjectSaveMode } from '../../../helpers';

let gridApi = null;
let gridColumnApi = null;

export const PageContent = (props) => {
  let eInput = null;
  let previousSelectedFilteredRows = [];
  const customerOptions = [];
  const digitalsOptions = [];
  const domainsOptions = [];
  const goalsOptions = [];
  const investmentOptions = [];
  const methodologiesOptions = [];
  const naturesOptions = [];
  const mandatoriesOptions = [];
  const prioritiesOptions = [];
  const prLivesOptions = [];
  const prStatusOptions = [];
  const portfolioOptions = [];
  const responsibilityOptions = [];
  const prApprovalOptions = [];
  const prPhaseOptions = [];
  const targetsOptions = [];
  const timingsOptions = [];
  const rebillingsOptions = [];
  const releaseDateOptions = [];
  const controllingAreaOptions = [];
  let allDomains = [];
  let allSubDomains = [];
  let allCustomers = [];
  let allSubCustomers = [];

  const { setBreadcrumbRoot } = useContext(NavContext);

  const {
    showSuccessMessage,
    showWarningMessage,
    showErrorMessage
  } = useContext(ToastContext);

  const {
    userInfo,
    isUserInRoles,
    layoutBudget,
    budgetYears,
    readOnlyMode
  } = useContext(UserContext);

  const {
    state,
    getRolesAsync,
    getRoleInfoAsync,
    getProjectManagersAsync,
    getLookupDataAsync,
    getProjectsAsync,
    getSapProjectsAsync,
    getBwProjectsAsync,
    saveProjectsAsync,
    saveMilestoneAsync,
    deleteMilestoneAsync,
    getUserSettingsAsync,
    saveUserSettingsAsync
  } = useContext(MyProjectsContext);

  const {
    roles,
    updatedView,
    ownerRoleInfo,
    lookUpData,
    isLoadingProjects,
    allProjects,
    sapProjects,
    bwProjects,
    userViews,
    errorMilestone,
    areProjectsSaved,
    missingFields,
    isRestoringProject,
    revertedProject
  } = state;

  const [selectedRows, setSelectedRows] = useState(null);
  const [columnDefs, setColumnDefs] = useState(null);
  const [activeSession, setActiveSession] = useState(null);
  const [deletedProjects, setDeletedProjects] = useState([]);
  const [lockingUnlocking, setLockingUnlocking] = useState(undefined); //the state initialization triggers its useEffect so a starting unique value is necessary to understand the only case useEffect shouldn't trigger
  const [selectedNodes, setSelectedNodes] = useState(null);
  const [updatedCurrentSession, setUpdatedCurrentSession] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [isGridChanged, setIsGridChanged] = useState(false);
  const [modifiedProjects, setModifiedProjects] = useState([]);
  const [unableFilters, setUnableFilters] = useState(false); //when adding new projects, this disable the saving of the grid's settings
  const [newCellValue, setNewCellValue] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [hasROValue, setHasROValue] = useState(false);
  const [projectsTeams, setProjectsTeams] = useState([]);
  const [areRowsFiltered, setAreRowsFiltered] = useState(false);
  const [interimFilters, setInterimFilters] = useState([]);
  const [components, setComponents] = useState({ datePicker: getDatePicker() });
  const [frameworkComponents, setFrameworkComponents] = useState({
    customPinnedRowRenderer: CustomPinnedRowRenderer
  });
  const [sideBar, setSideBar] = useState({
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel'
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel'
      }
    ],
    position: 'left'
  });
  const [defaultColDef, setDefaultColDef] = useState({
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    headerCheckboxSelection: isFirstColumn,
    checkboxSelection: isFirstColumn,
    editable: params => params.data.isLocked || (readOnlyMode && readOnlyMode.value) ? false : true,
    cellStyle: params => params.data.isLocked || (readOnlyMode && readOnlyMode.value) ? { color: 'grey' } : { color: '#000' }
  });

  useEffect(() => {
    getLookupDataAsync();
    getSapProjectsAsync();

    //avoiding useless calls for pms
    if (isUserInRoles([ApplicationRoles.Owner]))
      getRolesAsync();
  }, [])

  useEffect(() => {
    if (roles !== null) {
      let ownersId = null;

      if (roles.length > 0){
        roles.map(role => {
          if (role.groupName == "Owners")
            ownersId = role.applicationRoleId;
        });
      }

      if (ownersId)
        getRoleInfoAsync(ownersId);
    }
  }, [roles])

  useEffect(() => {
    if (ownerRoleInfo)
      getAllPms();
  }, [ownerRoleInfo])

  useEffect(() => {
    if (gridApi) {
      if (isLoadingProjects)
        gridApi.showLoadingOverlay();
      else
        gridApi.showNoRowsOverlay();
    }
  }, [isLoadingProjects])

  useEffect(() => {
    if (gridApi) {
      if (isRestoringProject)
        gridApi.showLoadingOverlay();
      else
        gridApi.showNoRowsOverlay();
    }
  }, [isRestoringProject])

  useEffect(() => {
    if (readOnlyMode)
      if (readOnlyMode.value)
        showWarningMessage("The system is in read only mode");
  }, [readOnlyMode])

  useEffect(() => {
    //undefined value indicates the initialization of this state and it avoids this useEffect to be triggered when there are no selected rows yet
    if (lockingUnlocking !== undefined){
      if (lockingUnlocking)
        lockUnlockProjects(true);
      
      //!lockingUnlocking can't be used because the state could also be null
      else if (lockingUnlocking === false){
        const selectedIds = selectedNodes.map(node => node.data.id);
        
        //in the assignBooleanValue function, false value doesn't trigger the changing of the cell, so the checkDoubleModifiedProjects function inside the onCellValueChanged grid event doesn't get triggered
        checkDoubleModifiedProjects(selectedIds);
  
        //false or null doesn't trigger the valueSetter
        lockUnlockProjects(" ");
      }
  
      //grid events don't finish immediately
      setTimeout(() => setLockingUnlocking(null), 500);
    }
  }, [lockingUnlocking])

  useEffect(() => {
    if (missingFields !== null) {
      const invalidFields = [];
      if (missingFields && missingFields.length > 0) {
        missingFields.map(emptyField => {
          const invalidName = emptyField.message.split("Invalid ")[1].split(" supplied")[0];
          const removeId = invalidName.indexOf("id") !== -1 ? invalidName.split(" id")[0] : invalidName;
          invalidFields.push(removeId);
        });

        const noDoubleFields = invalidFields.filter((a, b) => invalidFields.indexOf(a) === b);

        showErrorMessage(`Please check these invalid fields:\n ${noDoubleFields.map(field => { return "\n" + field; })}`);
      }
    }
  }, [missingFields])

  useEffect(() => {
    if (areProjectsSaved !== null) {
      if (areProjectsSaved) {
        setUnableFilters(false);
        setIsGridChanged(false);
        setModifiedProjects([]);

        //checking previous deleted projects
        if (deletedProjects.length > 0) {
          if (allProjects.length > 0) {
            const allProjectsId = [];
            allProjects.map(currentProject => allProjectsId.push(currentProject.projectId));

            const notDeletedProjects = allProjectsId.filter(x => deletedProjects.includes(x));

            if (notDeletedProjects.length > 0) {
              showWarningMessage(`The projects have been saved but due to RO fields, these projects have not been deleted: ${notDeletedProjects.join(', ')}`);
            }
            else
              showSuccessMessage("Modified projects have been successfully saved");
          }

          else if (allProjects.length === 0) {
            showSuccessMessage("All projects have been successfully deleted");
          }
        }

        else {
          if (allProjects.length === 0)
            showSuccessMessage("All projects have been successfully deleted");
          else
            showSuccessMessage("Modified projects have been successfully saved");
        }

        setDeletedProjects([]);
      }
      else
        setIsGridChanged(true);
    }
  }, [areProjectsSaved])

  useEffect(() => {
    if (readOnlyMode && updatedCurrentSession){
      if (!readOnlyMode.value && updatedCurrentSession.isActive && isUserInRoles([ApplicationRoles.Owner]))
        setIsEditable(true);
      else
        setIsEditable(false);
    }
  }, [readOnlyMode, updatedCurrentSession])

  useEffect(() => {
    if (layoutBudget !== null) {
      getBwProjectsAsync(layoutBudget.observedYear);

      //fixing a bug that happened by changing year while a cell was in editing mode
      if (gridApi)
        gridApi.stopEditing();

      let updatedObject = null;
      if (budgetYears && budgetYears.items && budgetYears.items.length > 0) {
        budgetYears.items.map(updatedSession => {
          if (layoutBudget.budgetYearId === updatedSession.budgetYearId)
            updatedObject = updatedSession;
        });
        setUpdatedCurrentSession(updatedObject);
      }

      setBreadcrumbRoot(`PPM IT - My projects (${layoutBudget.observedYear}\xa0\xa0\xa0${updatedObject && updatedObject.currentBudgetSession && updatedObject.currentBudgetSession.name}${updatedObject && updatedObject.isActive ? "\xa0\xa0\xa0Active" : ""})`);

      if (gridApi)
        gridApi.setColumnDefs(null);

      getUserSettingsAsync({ budgetYearId : layoutBudget.budgetYearId });
      setSelectedRows(null);
	    setSelectedNodes(null);
      setAreRowsFiltered(false);
      setIsGridChanged(false);
      setDeletedProjects([]);
      setModifiedProjects([]);
    }
  }, [layoutBudget])

  useEffect(() => {
    if (updatedCurrentSession !== null && lookUpData !== null && userViews !== null && (isUserInRoles([ApplicationRoles.Owner]) ? projectsTeams.length > 0 : true)){
      setDropDownOptions(lookUpData);

      const currentBudget = updatedCurrentSession.currentBudgetSession.name;
      let showBudget = null;

      if (currentBudget.indexOf("L01") != -1)
        showBudget = "01";
      else if (currentBudget.indexOf("L03") != -1)
        showBudget = "03";
      else if (currentBudget.indexOf("L06") != -1)
        showBudget = "06";
      else if (currentBudget.indexOf("L12") != -1)
        showBudget = "12";

      setActiveSession(showBudget);

      const allColumns = [
        {
          headerName: 'Year',
          field: 'year',
          filter: false,
          sortable: false,
          editable: false,
          cellStyle: { color: 'grey' },
          hide: true,
          width: 80
        },
        {
          headerName: 'ID',
          field: 'id',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            //clearButton: true,
            //cancelButton: true, ???
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' },
          width: 90
        },
        {
          headerName: 'Locked',
          field: 'isLocked',
          filter: true,
          sortable: true,
          editable: false,
          width: 100,
          valueSetter: params => assignBooleanValue(params),
          cellRenderer: params => params.value ? '&#x1f6c7' : null //assigning UI values
        },
        {
          headerName: 'SAP Initiative',
          field: 'sap initiative',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellRenderer: allowOnlyDigits
        },
        {
          headerName: 'Domain*',
          field: 'domain',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: domainsOptions
          }
        },
        {
          headerName: 'Sub Domain*',
          field: 'sub domain',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: { values: [] },
          valueGetter: params => {
            const subDomainOptions = [];

            if (allDomains.length > 0 && allSubDomains.length > 0) {
              allDomains.map(choosenDomain => {
                if (params.data.domain == choosenDomain.title) {
                  allSubDomains.map(relatedSubDomain => {
                    if (relatedSubDomain.parentId === choosenDomain.id)
                      subDomainOptions.push(relatedSubDomain.title);
                  });
                }
              });
            }

            params.colDef.cellEditorParams.values = subDomainOptions;

            return params.data['sub domain'];
          }
        },
        {
          headerName: 'Project Name*',
          field: 'project name',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' }
        },
        {
          headerName: "IT Owner*",
          field: "it owner",
          filter: "agSetColumnFilter",
          editable: false,
          cellStyle: { color: 'grey' }
        },
        {
          headerName: "Sub Owner",
          field: "sub owner",
          filter: "agSetColumnFilter",
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: { values: [] },
          valueGetter: params => {
            const subOwnerOptions = [];

            if (projectsTeams && projectsTeams.length > 0){
              projectsTeams.map(team => {
                if (
                  team.owner.displayName === params.data["it owner"] &&
                  team.projectManagers.length > 0
                )
                  team.projectManagers.map(pm =>
                    subOwnerOptions.push(pm.displayName)
                  );
              });
            }            

            params.colDef.cellEditorParams.values = subOwnerOptions;
            return params.data['sub owner'];
          }
        },
        {
          headerName: 'Business Owner',
          field: 'business owner',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
        },
        {
          headerName: 'Target region*',
          field: 'target region',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: targetsOptions
          }
        },
        {
          headerName: 'Customer*',
          field: 'customer',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: customerOptions
          }
        },
        {
          headerName: 'Sub Customer',
          field: 'sub-customer',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: { values: [] },
          valueGetter: params => {
            const subCustomerOptions = [];

            if (allCustomers.length > 0 && allSubCustomers.length > 0) {
              allCustomers.map(choosenCustomer => {
                if (params.data.customer == choosenCustomer.title) {
                  allSubCustomers.map(relatedSubCustomer => {
                    if (relatedSubCustomer.parentId === choosenCustomer.id)
                      subCustomerOptions.push(relatedSubCustomer.title);
                  });
                }
              });
            }

            params.colDef.cellEditorParams.values = subCustomerOptions;

            return params.data['sub-customer'];
          }
        },
        {
          headerName: 'Goal',
          field: 'goal',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: goalsOptions
          }
        },
        {
          headerName: 'Timing',
          field: 'timing',
          filter: 'agSetColumnFilter',
          editable: false,
          cellStyle: { color: 'grey' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: timingsOptions
          }
        },
        {
          headerName: 'Priority',
          field: 'priority',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: prioritiesOptions
          }
        },
        {
          headerName: 'Nature*',
          field: 'nature',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: naturesOptions
          }
        },
        {
          headerName: 'Investment mix*',
          field: 'investment mix',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: investmentOptions
          }
        },
        {
          headerName: 'Mandatory',
          field: 'mandatory',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: mandatoriesOptions
          }
        },
        {
          headerName: 'Methodology',
          field: 'methodology',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: methodologiesOptions
          }
        },
        {
          headerName: 'Digital spending',
          field: 'digital',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: digitalsOptions
          }
        },
        {
          headerName: 'Project Approval*',
          field: 'project approval',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: prApprovalOptions
          }
        },
        {
          headerName: 'Project Phase*',
          field: 'project phase',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: prPhaseOptions
          }
        },
        {
          headerName: 'Progress %',
          field: 'progress',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          cellRenderer: allowOnlyDigits
        },
        {
          headerName: 'Project KO value',
          field: 'project ko',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Connected Costs',
          field: 'connected costs',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'H/W Connected Investments',
          field: 'h/w connected investments',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L01',
          field: 'l01',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget.indexOf("L01") != -1 ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-D1',
          field: 'l01-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01-D1" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01-D1" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L01-D1" || currentBudget == "L01-D2" || currentBudget == "L01-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-S1',
          field: 'l01-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L01-D1" || currentBudget == "L01-D2" || currentBudget == "L01-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l01) + Number(data[`l01-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L01-D2',
          field: 'l01-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01-D2" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01-D2" ? { color: 'grey' } : { color: '#000' },
          hide: currentBudget == "L01-D2" || currentBudget == "L01-D3" ? false : true,
          valueSetter: params => changingNumericField(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-S2',
          field: 'l01-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L01-D2" || currentBudget == "L01-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l01) + Number(data[`l01-d1`]) + Number(data[`l01-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L01-D3',
          field: 'l01-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01-D3" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L01-D3" ? { color: 'grey' } : { color: '#000' },
          hide: currentBudget == "L01-D3" ? false : true,
          valueSetter: params => changingNumericField(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-RO',
          field: 'l01-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L01-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l01) + Number(data[`l01-d1`]) + Number(data[`l01-d2`]) + Number(data[`l01-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03',
          field: 'l03',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget.indexOf("L03") != -1 ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-D1',
          field: 'l03-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03-D1" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03-D1" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L03-D1" || currentBudget == "L03-D2" || currentBudget == "L03-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-S1',
          field: 'l03-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L03-D1" || currentBudget == "L03-D2" || currentBudget == "L03-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l03) + Number(data[`l03-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03-D2',
          field: 'l03-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03-D2" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03-D2" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L03-D2" || currentBudget == "L03-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-S2',
          field: 'l03-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L03-D2" || currentBudget == "L03-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l03) + Number(data[`l03-d1`]) + Number(data[`l03-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03-D3',
          field: 'l03-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03-D3" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L03-D3" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L03-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-RO',
          field: 'l03-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L03-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l03) + Number(data[`l03-d1`]) + Number(data[`l03-d2`]) + Number(data[`l03-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06',
          field: 'l06',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget.indexOf("L06") != -1 ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-D1',
          field: 'l06-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06-D1" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06-D1" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L06-D1" || currentBudget == "L06-D2" || currentBudget == "L06-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-S1',
          field: 'l06-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L06-D1" || currentBudget == "L06-D2" || currentBudget == "L06-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l06) + Number(data[`l06-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06-D2',
          field: 'l06-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06-D2" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06-D2" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L06-D2" || currentBudget == "L06-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-S2',
          field: 'l06-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L06-D2" || currentBudget == "L06-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l06) + Number(data[`l06-d1`]) + Number(data[`l06-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06-D3',
          field: 'l06-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06-D3" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L06-D3" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L06-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-RO',
          field: 'l06-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L06-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l06) + Number(data[`l06-d1`]) + Number(data[`l06-d2`]) + Number(data[`l06-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L12',
          field: 'l12',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget.indexOf("L12") != -1 ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-D1',
          field: 'l12-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12-D1" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12-D1" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L12-D1" || currentBudget == "L12-D2" || currentBudget == "L12-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-S1',
          field: 'l12-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L12-D1" || currentBudget == "L12-D2" || currentBudget == "L12-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l12) + Number(data[`l12-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L12-D2',
          field: 'l12-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12-D2" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12-D2" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L12-D2" || currentBudget == "L12-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-S2',
          field: 'l12-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L12-D2" || currentBudget == "L12-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l12) + Number(data[`l12-d1`]) + Number(data[`l12-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L12-D3',
          field: 'l12-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12-D3" ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable || currentBudget !== "L12-D3" ? { color: 'grey' } : { color: '#000' },
          valueSetter: params => changingNumericField(params),
          hide: currentBudget == "L12-D3" ? false : true,
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-RO',
          field: 'l12-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          hide: currentBudget == "L12-D3" ? false : true,
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l12) + Number(data[`l12-d1`]) + Number(data[`l12-d2`]) + Number(data[`l12-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Commitment',
          field: 'commitment',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders',
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Actual',
          field: 'actual',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders',
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Project Final Value',
          field: 'project final value',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' },
          valueSetter: params => changingNumericField(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Estimation',
          field: 'estimation',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          //editable: params => estimationEditabilityCondition(params),
          //cellStyle: params => estimationEditabilityCondition(params) ? { color: '#000' } : { color: 'grey' },
          valueSetter: params => changingNumericField(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Rebilling',
          field: 'rebilling',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: rebillingsOptions
          }
        },
        {
          headerName: 'Release Date',
          field: 'release date',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: releaseDateOptions
          }
        },
        {
          headerName: 'Project Life',
          field: 'project life',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: prLivesOptions
          }
        },
        {
          headerName: 'Project Status',
          field: 'project status',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: prStatusOptions
          }
        },
        {
          headerName: 'Portfolio Mix*',
          field: 'portfolio mix',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: portfolioOptions
          }/*,
          valueSetter: params => handlingEstimationValue(params)*/
        },
        {
          headerName: 'Responsibility Center*',
          field: 'responsibility center',
          filter: 'agSetColumnFilter',
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: responsibilityOptions
          }
        },
        {
          headerName: 'Current',
          field: 'current',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' },
          valueGetter: `Number(data.l${showBudget}) + Number(data['l${showBudget}-d1']) + Number(data['l${showBudget}-d2']) + Number(data['l${showBudget}-d3'])`,
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders',
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'YTG',
          field: 'ytg',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueGetter: `(Number(data.l${showBudget}) + Number(data['l${showBudget}-d1']) + Number(data['l${showBudget}-d2']) + Number(data['l${showBudget}-d3'])) - data.actual - data.commitment`,
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders'
        },
        {
          headerName: 'Notes',
          field: 'notes',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? false : true,
          cellStyle: params => params.data.isLocked || params.node.rowPinned == "top" || params.data.ownerKey !== (userInfo && userInfo.externalKey) || !isEditable ? { color: 'grey' } : { color: '#000' },
          cellEditor: 'agLargeTextCellEditor',
          cellEditorParams: {
            maxLength: 500,
            //rows: 10,
            //cols: 60,
          },
          headerClass: 'yellowHeaders'
        },
        {
          headerName: 'Last Modified Date',
          field: 'last modified date',
          editable: false,
          cellStyle: { color: 'grey' },
          comparator: dateComparator,
          filter: 'agDateColumnFilter',
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              const dateParts = cellValue.split(' ')[0].split('/');

              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );

              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime())
                return 0;

              if (cellDate < filterLocalDateAtMidnight)
                return -1;

              if (cellDate > filterLocalDateAtMidnight)
                return 1;
            }
          }
        },
        {
          headerName: 'Last Modified By',
          field: 'last modified by',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          editable: false,
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Controlling area SAP',
          field: 'controlling area sap',
          filter: "agSetColumnFilter",
          editable: false,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: controllingAreaOptions
          },
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Initiative description SAP',
          field: 'initiative description sap',
          editable: false,
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Created date SAP',
          field: 'created date sap',
          editable: false,
          comparator: dateComparator,
          filter: 'agDateColumnFilter',
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              const dateParts = cellValue.split(' ')[0].split('/');

              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );

              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime())
                return 0;

              if (cellDate < filterLocalDateAtMidnight)
                return -1;

              if (cellDate > filterLocalDateAtMidnight)
                return 1;
            }
          },
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Profit center SAP',
          field: 'profit center sap',
          editable: false,
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'It Owner SAP',
          field: 'it owner sap',
          editable: false,
          filter: "agSetColumnFilter",
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Order type SAP',
          field: 'order type sap',
          editable: false,
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Customer SAP',
          field: 'customer sap',
          editable: false,
          filter: 'agSetColumnFilter',
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: {
            values: customerOptions
          },
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'L01-RO BW',
          field: 'l01-ro bw',
          editable: false,
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03-RO BW',
          field: 'l03-ro bw',
          editable: false,
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06-RO BW',
          field: 'l06-ro bw',
          editable: false,
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        }
      ];

      //cannot use directly setColumnDefs(allColumns)
      if (gridApi)
        gridApi.setColumnDefs(allColumns);
      
      getProjectsAsync(layoutBudget.observedYear);
      setIsGridChanged(false);
    }
  }, [lookUpData, userViews, projectsTeams])

  //from database to grid
  useEffect(() => {
    if (lookUpData !== null && allProjects !== null && sapProjects !== null && bwProjects !== null) {
      setUnableFilters(false);
      const projectsData = [];

      if (allProjects.length > 0) {
        allProjects.map(project => {
          const domainString = getDataValue(project.domainId, lookUpData.domains);
          const subDomainString = getDataValue(project.subDomainId, lookUpData.subDomains);
          const timingString = getDataValue(project.timingId, lookUpData.timings);
          const customerString = getDataValue(project.customerId, lookUpData.customers);
          const subCustomerString = getDataValue(project.subCustomerId, lookUpData.subCustomers);
          const goalString = getDataValue(project.goalId, lookUpData.goals);
          const priorityString = getDataValue(project.priorityId, lookUpData.priorities);
          const natureString = getDataValue(project.natureId, lookUpData.natures);
          const investmentString = getDataValue(project.investmentMixId, lookUpData.investmentMixes);
          const mandatoryString = getDataValue(project.mandatoryId, lookUpData.mandatories);
          const methodologyString = getDataValue(project.methodologyId, lookUpData.methodologies);
          const digitalString = getDataValue(project.digitalId, lookUpData.digitals);
          const prLivesString = getDataValue(project.projectLifeId, lookUpData.projectLives);
          const prStatusString = getDataValue(project.projectStatusId, lookUpData.projectStatus);
          const portfolioString = getDataValue(project.portfolioMixId, lookUpData.portfolioMixes);
          const responsibilityString = getDataValue(project.responsibilityCenterId, lookUpData.responsibilityCenters);
          const prApprovalString = getDataValue(project.projectApprovalId, lookUpData.projectApprovals);
          const prPhaseString = getDataValue(project.projectPhaseId, lookUpData.projectPhases);
          const targetString = getDataValue(project.targetId, lookUpData.targets);
          const rebillingString = getDataValue(project.rebillingId, lookUpData.rebillings, "Rebilling");
          const releaseDateString = getDataValue(project.releaseDateId, lookUpData.releaseDates, "Release Date");
          
          //sftp sap projects integration
          let controllingAreaString = "";
          let description = "";
          let createdDate = "";
          let profitCenter = "";
          let itOwnerSap = "";
          let orderType = "";
          let internalCustomer = "";
          const isSap = sapProjects.some(sp => sp.sapInitiative === project.sapInitiative);

          if (isSap){
            const sapProject = sapProjects.filter(sp => sp.sapInitiative === project.sapInitiative)[0];
            controllingAreaString = getDataValue(sapProject.controllingArea, lookUpData.controllingAreas, "Controlling area SAP");
            description = sapProject.description;
            profitCenter = sapProject.profitCenter;
            const checkCreatedDate = sapProject.createdDate.indexOf('Z') !== -1 ? sapProject.createdDate : sapProject.createdDate + "Z";
            createdDate = moment(new Date(checkCreatedDate)).format("DD/MM/YYYY");
            itOwnerSap = sapProject.itOwner;
            orderType = sapProject.orderType;
            internalCustomer = getDataValue(Number(sapProject.internalCustomer), lookUpData.customers);
          }

          //sftp bw projects integration
          let bwActual = 0;
          let bwCommitment = 0;
          let bwL01 = 0;
          let bwL03 = 0;
          let bwL06 = 0;
          const isBw = bwProjects.some(bp => bp.initiative === project.sapInitiative);

          if (isBw){
            const bwProject = bwProjects.filter(bp => bp.initiative === project.sapInitiative)[0];
            bwActual = bwProject.act;
            bwCommitment = bwProject.commitments;
            bwL01 = bwProject.bdg;
            bwL03 = bwProject.fcT39;
            bwL06 = bwProject.fcT84;
          }

          let lastModifiedDate = null;
          if (project.updateDate) {
            const checkDate = project.updateDate.indexOf('Z') !== -1 ? project.updateDate : project.updateDate + "Z";
            const date = new Date(checkDate);
            lastModifiedDate = moment(date).format("DD/MM/YYYY H:mm:ss");
          }

          projectsData.push({
            id: project.projectId,
            'project name': project.name,
            ownerKey: project.ownerKey, //there isn't a column for this property (it is used for columns editability)
            'it owner': project.ownerFullName,
            'sub owner': project.subOwnerFullName, //there isn't a column for this property
            'business owner': project.businessOwner,
            year: project.year,
            'sap initiative': project.sapInitiative,
            domain: domainString,
            'sub domain': subDomainString,
            'target region': targetString,
            customer: customerString,
            'sub-customer': subCustomerString,
            goal: goalString,
            timing: timingString,
            priority: priorityString,
            nature: natureString,
            'investment mix': investmentString,
            mandatory: mandatoryString,
            methodology: methodologyString,
            digital: digitalString,
            'project life': prLivesString,
            'project status': prStatusString,
            'portfolio mix': portfolioString,
            'responsibility center': responsibilityString,
            'project approval': prApprovalString,
            'project phase': prPhaseString,
            rebilling: rebillingString,
            'release date': releaseDateString,
            progress: project.progress,
            estimation: project.estimation,
            'project ko': project.projectKO,
            'connected costs': project.connectedCosts,
            'h/w connected investments': project.hardwareConnectedInvestments,
            l01: project.l01,
            'l01-d1': project.l01D1,
            'l01-d2': project.l01D2,
            'l01-d3': project.l01D3,
            l03: project.l03,
            'l03-d1': project.l03D1,
            'l03-d2': project.l03D2,
            'l03-d3': project.l03D3,
            l06: project.l06,
            'l06-d1': project.l06D1,
            'l06-d2': project.l06D2,
            'l06-d3': project.l06D3,
            l12: project.l12,
            'l12-d1': project.l12D1,
            'l12-d2': project.l12D2,
            'l12-d3': project.l12D3,
            'project final value': project.projectFinalValue,
            commitment: bwCommitment,
            actual: bwActual,
            notes: project.notes,
            'last modified date': lastModifiedDate,
            'last modified by': project.updatedByFullName,
            'isLocked': project.isLocked,
            'controlling area sap': controllingAreaString,
            'initiative description sap': description,
            'created date sap': createdDate,
            'profit center sap': profitCenter,
            'it owner sap': itOwnerSap,
            'order type sap': orderType,
            'customer sap': internalCustomer,
            'l01-ro bw': bwL01,
            'l03-ro bw': bwL03,
            'l06-ro bw': bwL06
          });
        });
      }

      setRowData(projectsData);

      if (allProjects.length > 0)
        if (document.querySelector(".ag-overlay-no-rows-center"))
          document.querySelector(".ag-overlay-no-rows-center").style.display = "none";
    }
  }, [lookUpData, allProjects, sapProjects, bwProjects])

  //default active filter called once after the grid is loaded
  useEffect(() => {
    if (rowData !== null){
      //when projects are saved, initial filters mustn't be applied
      if (!areProjectsSaved){
        if (userViews !== null){
          const activeView = userViews.filter(view => view.isUsed);
          const blobColumns = activeView && activeView[0] && JSON.parse(activeView[0].gridSettings);
    
          if (blobColumns){
            applyColumns(blobColumns);
    
            if (blobColumns[4] && blobColumns[4].length > 0)
              applyFilters(blobColumns[4]);
            else //when user doesn't have a view with filters enabled
              updateTopRowSum();
          }
          else //when user doesn't have an active view
            updateTopRowSum();
        }
        else //when user doesn't have any view
          updateTopRowSum();
      }
      
      //applying interim not saved filters
      else if (interimFilters.length > 0)
        applyFilters(interimFilters);
    }
  }, [rowData, userViews])

  useEffect(() => {
    if (updatedView !== null && !updatedView.isDeleted && gridColumnApi){
      const blobColumns = JSON.parse(updatedView.gridSettings);

      if (blobColumns){
        clearingFilters();
        applyColumns(blobColumns);
        applyFilters(blobColumns[4]);
      }
    }
  }, [updatedView])

  useEffect(() => {
    if (rowData !== null && newCellValue !== null && activeSession !== null) {
      setNewCellValue(false);
      updateTopRowSum();
    }
  }, [newCellValue, activeSession])

  useEffect(() => {
    if (revertedProject !== null){
      //with agRichSelectCellEditor gridApi.startEditingCell() doesn't work
      const customerId = getDataValue(revertedProject.customerId, lookUpData.customers);
      const subCustomerId = getDataValue(revertedProject.subCustomerId, lookUpData.subCustomers);
      const digitalId = getDataValue(revertedProject.digitalId, lookUpData.digitals);
      const domainTitle = getDataValue(revertedProject.domainId, lookUpData.domains);
      const subDomainId = getDataValue(revertedProject.subDomainId, lookUpData.subDomains);
      const goalId = getDataValue(revertedProject.goalId, lookUpData.goals);
      const methodologyId = getDataValue(revertedProject.methodologyId, lookUpData.methodologies);
      const natureId = getDataValue(revertedProject.natureId, lookUpData.natures);
      const investmentId = getDataValue(revertedProject.investmentMixId, lookUpData.investmentMixes);
      const mandatoryId = getDataValue(revertedProject.mandatoryId, lookUpData.mandatories);
      const priorityId = getDataValue(revertedProject.priorityId, lookUpData.priorities);
      const prLivesId = getDataValue(revertedProject.projectLifeId, lookUpData.projectLives);
      const prStatusId = getDataValue(revertedProject.projectStatusId, lookUpData.projectStatus);
      const portfolioId = getDataValue(revertedProject.portfolioMixId, lookUpData.portfolioMixes);
      const responsibilityId = getDataValue(revertedProject.responsibilityCenterId, lookUpData.responsibilityCenters);
      const prApprovalId = getDataValue(revertedProject.projectApprovalId, lookUpData.projectApprovals);
      const prPhaseId = getDataValue(revertedProject.projectPhaseId, lookUpData.projectPhases);
      const timingId = getDataValue(revertedProject.timingId, lookUpData.timings);
      const targetId = getDataValue(revertedProject.targetId, lookUpData.targets);
      const rebillingId = getDataValue(revertedProject.rebillingId, lookUpData.rebillings, "Rebilling");
      const releaseDateId = getDataValue(revertedProject.releaseDateId, lookUpData.releaseDates, "Release Date");

      selectedNodes[0].data.actual = revertedProject.actual;
      selectedNodes[0].data["business owner"] = revertedProject.businessOwner;
      selectedNodes[0].data.commitment = revertedProject.committment;
      selectedNodes[0].data["connected costs"] = revertedProject.connectedCosts;
      selectedNodes[0].data.customer = customerId;
      selectedNodes[0].data.digital = digitalId;
      selectedNodes[0].data.domain = domainTitle;
      selectedNodes[0].data.estimation = revertedProject.estimation;
      selectedNodes[0].data.goal = goalId;
      selectedNodes[0].data["h/w connected investments"] = revertedProject.hardwareConnectedInvestments;
      selectedNodes[0].data.isLocked = revertedProject.isLocked;
      selectedNodes[0].data["it owner"] = revertedProject.ownerFullName;
      selectedNodes[0].data["sub owner"] = revertedProject.pmFullName;
      selectedNodes[0].data.l01 = revertedProject.l01;
      selectedNodes[0].data["l01-d1"] = revertedProject.l01D1;
      selectedNodes[0].data["l01-d2"] = revertedProject.l01D2;
      selectedNodes[0].data["l01-d3"] = revertedProject.l01D3;
      selectedNodes[0].data.l03 = revertedProject.l03;
      selectedNodes[0].data["l03-d1"] = revertedProject.l03D1;
      selectedNodes[0].data["l03-d2"] = revertedProject.l03D2;
      selectedNodes[0].data["l03-d3"] = revertedProject.l03D3;
      selectedNodes[0].data.l06 = revertedProject.l06;
      selectedNodes[0].data["l06-d1"] = revertedProject.l06D1;
      selectedNodes[0].data["l06-d2"] = revertedProject.l06D2;
      selectedNodes[0].data["l06-d3"] = revertedProject.l06D3;
      selectedNodes[0].data.l12 = revertedProject.l12;
      selectedNodes[0].data["l12-d1"] = revertedProject.l12D1;
      selectedNodes[0].data["l12-d2"] = revertedProject.l12D2;
      selectedNodes[0].data["l12-d3"] = revertedProject.l12D3;
      selectedNodes[0].data.methodology = methodologyId;
      selectedNodes[0].data.nature = natureId;
      selectedNodes[0].data["investment mix"] = investmentId;
      selectedNodes[0].data.mandatory = mandatoryId;
      selectedNodes[0].data.notes = revertedProject.notes;
      selectedNodes[0].data.ownerKey = revertedProject.ownerKey;
      selectedNodes[0].data["portfolio mix"] = portfolioId;
      selectedNodes[0].data.priority = priorityId;
      selectedNodes[0].data.progress = revertedProject.progress;
      selectedNodes[0].data["project approval"] = prApprovalId;
      selectedNodes[0].data["project final value"] = revertedProject.projectFinalValue;
      selectedNodes[0].data["project ko"] = revertedProject.projectKO;
      selectedNodes[0].data["project life"] = prLivesId;
      selectedNodes[0].data["project name"] = revertedProject.name;
      selectedNodes[0].data["project phase"] = prPhaseId;
      selectedNodes[0].data["project status"] = prStatusId;
      selectedNodes[0].data.rebilling = rebillingId;
      selectedNodes[0].data["release date"] = releaseDateId;
      selectedNodes[0].data["responsibility center"] = responsibilityId;
      selectedNodes[0].data["sap initiative"] = revertedProject.sapInitiative;
      selectedNodes[0].data["sub domain"] = subDomainId;
      selectedNodes[0].data["sub-customer"] = subCustomerId;
      selectedNodes[0].data["target region"] = targetId;
      selectedNodes[0].data.timing = timingId;
      gridApi.redrawRows({ rowNodes: selectedNodes });
      gridApi.deselectAll();

      //adding reverted project to the modified array
      checkDoubleModifiedProjects([selectedNodes[0].data.id]);
      
      setSelectedNodes(null);
      setSelectedRows(null);
      setIsGridChanged(true);

      if (document.querySelector(".ag-overlay-no-rows-center"))
        document.querySelector(".ag-overlay-no-rows-center").style.display = "none";
    }
  }, [revertedProject])

  useEffect(() => {
    if (unableFilters) {
      setInterimFilters(getCurrentFilters());
      gridApi.setFilterModel(null);
    }
  }, [unableFilters]);

  /*function estimationEditabilityCondition(params){
    return !params.data.isLocked && params.node.rowPinned !== "top" && params.data.ownerKey === (userInfo && userInfo.externalKey) && isEditable && (!params.data["portfolio mix"] || params.data["portfolio mix"].toLowerCase() !== "ktlo" && params.data["portfolio mix"].toLowerCase() !== "carry over" && params.data["portfolio mix"].toLowerCase() !== "mandatory")
  }*/

  async function getAllPms(){
    const relatedPms = [];
    
    await Promise.all(
      ownerRoleInfo.members.map(async role => {
        if (role.externalKey){
          const team = await getProjectManagersAsync(role.externalKey);

          if (team.projectTeamId)
            relatedPms.push(team);
        }
      })
    );
    
    setProjectsTeams(relatedPms);
  }

  function lockUnlockProjects(isLocking){
    gridColumnApi.getColumn("isLocked").colDef.editable = true;
    const isLockedVisibility = gridColumnApi.getColumn("isLocked").visible;
    const isLockedPinned = gridColumnApi.getColumn("isLocked").pinned;
    const isLockedIndex = gridColumnApi.getAllDisplayedColumns().findIndex(column => column.userProvidedColDef.field === "isLocked");
    
    //only visible fields can be changed
    gridColumnApi.setColumnVisible('isLocked', true);
    //pinning moves the column instead of the horizontal scrollbar
    gridColumnApi.setColumnPinned('isLocked', 'left');

    selectedNodes.map(node =>
      gridApi.startEditingCell({
        rowIndex: node.rowIndex,
        colKey: 'isLocked',
        charPress: isLocking
      })
    );

    if (!isLockedVisibility){
      gridColumnApi.setColumnPinned('isLocked', null);
      gridColumnApi.setColumnVisible('isLocked', false);
    }

    else {
      if (isLockedPinned)
        gridColumnApi.setColumnPinned('isLocked', isLockedPinned);
        
      else {
        gridColumnApi.setColumnPinned('isLocked', null);
        gridColumnApi.moveColumn("isLocked", isLockedIndex);
      }
    }
    
    gridApi.stopEditing();
    gridApi.deselectAll();
    gridColumnApi.getColumn("isLocked").colDef.editable = false;

    //redrawing locked rows so the cellRender gets triggered and the grey color can be loaded for each field
    gridApi.redrawRows({ rowNodes: selectedNodes });

    setSelectedRows(null);
    setSelectedNodes(null);
    setIsGridChanged(true);
  }

  function isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  function updateTopRowSum() {
    let projectKOSum = null;
    let connectedCostsSum = null;
    let HWInvestmentsSum = null;
    let l01Sum = null;
    let l01D1Sum = null;
    let l01S1Sum = null;
    let l01D2Sum = null;
    let l01S2Sum = null;
    let l01D3Sum = null;
    let l01ROSum = null;
    let l03Sum = null;
    let l03D1Sum = null;
    let l03S1Sum = null;
    let l03D2Sum = null;
    let l03S2Sum = null;
    let l03D3Sum = null;
    let l03ROSum = null;
    let l06Sum = null;
    let l06D1Sum = null;
    let l06S1Sum = null;
    let l06D2Sum = null;
    let l06S2Sum = null;
    let l06D3Sum = null;
    let l06ROSum = null;
    let l12Sum = null;
    let l12D1Sum = null;
    let l12S1Sum = null;
    let l12D2Sum = null;
    let l12S2Sum = null;
    let l12D3Sum = null;
    let l12ROSum = null;
    let estimationSum = null;
    let commitmentSum = null;
    let actualSum = null;
    let prFinalValue = null;
    let currentValue = null;
    let ytgValue = null;
    let l01BWSum = null;
    let l03BWSum = null;
    let l06BWSum = null;

    gridApi.forEachNodeAfterFilter(rowNode => {
      if (rowNode.data && rowNode.data.id) {
        projectKOSum += Number(rowNode.data['project ko']);
        connectedCostsSum += Number(rowNode.data['connected costs']);
        HWInvestmentsSum += Number(rowNode.data['h/w connected investments']);
        l01Sum += Number(rowNode.data.l01);
        l01D1Sum += Number(rowNode.data['l01-d1']);
        l01S1Sum += (Number(rowNode.data.l01) + Number(rowNode.data['l01-d1']));
        l01D2Sum += Number(rowNode.data['l01-d2']);
        l01S2Sum += (Number(rowNode.data.l01) + Number(rowNode.data['l01-d1']) + Number(rowNode.data['l01-d2']));
        l01D3Sum += Number(rowNode.data['l01-d3']);
        l01ROSum += (Number(rowNode.data.l01) + Number(rowNode.data['l01-d1']) + Number(rowNode.data['l01-d2']) + Number(rowNode.data['l01-d3']));
        l03Sum += Number(rowNode.data.l03);
        l03D1Sum += Number(rowNode.data['l03-d1']);
        l03S1Sum += (Number(rowNode.data.l03) + Number(rowNode.data['l03-d1']));
        l03D2Sum += Number(rowNode.data['l03-d2']);
        l03S2Sum += (Number(rowNode.data.l03) + Number(rowNode.data['l03-d1']) + Number(rowNode.data['l03-d2']));
        l03D3Sum += Number(rowNode.data['l03-d3']);
        l03ROSum += (Number(rowNode.data.l03) + Number(rowNode.data['l03-d1']) + Number(rowNode.data['l03-d2']) + Number(rowNode.data['l03-d3']));
        l06Sum += Number(rowNode.data.l06);
        l06D1Sum += Number(rowNode.data['l06-d1']);
        l06S1Sum += (Number(rowNode.data.l06) + Number(rowNode.data['l06-d1']));
        l06D2Sum += Number(rowNode.data['l06-d2']);
        l06S2Sum += (Number(rowNode.data.l06) + Number(rowNode.data['l06-d1']) + Number(rowNode.data['l06-d2']));
        l06D3Sum += Number(rowNode.data['l06-d3']);
        l06ROSum += (Number(rowNode.data.l06) + Number(rowNode.data['l06-d1']) + Number(rowNode.data['l06-d2']) + Number(rowNode.data['l06-d3']));
        l12Sum += Number(rowNode.data.l12);
        l12D1Sum += Number(rowNode.data['l12-d1']);
        l12S1Sum += (Number(rowNode.data.l12) + Number(rowNode.data['l12-d1']));
        l12D2Sum += Number(rowNode.data['l12-d2']);
        l12S2Sum += (Number(rowNode.data.l12) + Number(rowNode.data['l12-d1']) + Number(rowNode.data['l12-d2']));
        l12D3Sum += Number(rowNode.data['l12-d3']);
        l12ROSum += (Number(rowNode.data.l12) + Number(rowNode.data['l12-d1']) + Number(rowNode.data['l12-d2']) + Number(rowNode.data['l12-d3']));
        estimationSum += Number(rowNode.data.estimation);
        commitmentSum += Number(rowNode.data.commitment);
        actualSum += Number(rowNode.data.actual);
        prFinalValue += Number(rowNode.data['project final value']);
        currentValue += (Number(rowNode.data[`l${activeSession}`]) + Number(rowNode.data[`l${activeSession}-d1`]) + Number(rowNode.data[`l${activeSession}-d2`]) + Number(rowNode.data[`l${activeSession}-d3`]));
        ytgValue += ((Number(rowNode.data[`l${activeSession}`]) + Number(rowNode.data[`l${activeSession}-d1`]) + Number(rowNode.data[`l${activeSession}-d2`]) + Number(rowNode.data[`l${activeSession}-d3`])) - Number(rowNode.data.actual) - Number(rowNode.data.commitment));
        l01BWSum += Number(rowNode.data['l01-ro bw']);
        l03BWSum += Number(rowNode.data['l03-ro bw']);
        l06BWSum += Number(rowNode.data['l06-ro bw']);
      }
    });

    const row = [{
      'project ko': currencyFormatter(projectKOSum),
      'connected costs': currencyFormatter(connectedCostsSum),
      'h/w connected investments': currencyFormatter(HWInvestmentsSum),
      l01: currencyFormatter(l01Sum),
      'l01-d1': currencyFormatter(l01D1Sum),
      'l01-s1': currencyFormatter(l01S1Sum),
      'l01-d2': currencyFormatter(l01D2Sum),
      'l01-s2': currencyFormatter(l01S2Sum),
      'l01-d3': currencyFormatter(l01D3Sum),
      'l01-ro': currencyFormatter(l01ROSum),
      l03: currencyFormatter(l03Sum),
      'l03-d1': currencyFormatter(l03D1Sum),
      'l03-s1': currencyFormatter(l03S1Sum),
      'l03-d2': currencyFormatter(l03D2Sum),
      'l03-s2': currencyFormatter(l03S2Sum),
      'l03-d3': currencyFormatter(l03D3Sum),
      'l03-ro': currencyFormatter(l03ROSum),
      l06: currencyFormatter(l06Sum),
      'l06-d1': currencyFormatter(l06D1Sum),
      'l06-s1': currencyFormatter(l06S1Sum),
      'l06-d2': currencyFormatter(l06D2Sum),
      'l06-s2': currencyFormatter(l06S2Sum),
      'l06-d3': currencyFormatter(l06D3Sum),
      'l06-ro': currencyFormatter(l06ROSum),
      l12: currencyFormatter(l12Sum),
      'l12-d1': currencyFormatter(l12D1Sum),
      'l12-s1': currencyFormatter(l12S1Sum),
      'l12-d2': currencyFormatter(l12D2Sum),
      'l12-s2': currencyFormatter(l12S2Sum),
      'l12-d3': currencyFormatter(l12D3Sum),
      'l12-ro': currencyFormatter(l12ROSum),
      estimation: currencyFormatter(estimationSum),
      commitment: currencyFormatter(commitmentSum),
      actual: currencyFormatter(actualSum),
      'project final value': currencyFormatter(prFinalValue),
      current: currencyFormatter(currentValue),
      ytg: currencyFormatter(ytgValue),
      'l01-ro bw': currencyFormatter(l01BWSum),
      'l03-ro bw': currencyFormatter(l03BWSum),
      'l06-ro bw': currencyFormatter(l06BWSum)
    }];

    gridApi.setPinnedTopRowData(row);
  }

  function getDataValue(dbProject, lookupField, extraField) {
    let value = null;

    if (lookupField && lookupField.length > 0){
      if (extraField){
        if (extraField === "Controlling area SAP")
          lookupField.map(lookupData => {
            if (dbProject === lookupData.code)
              value = lookupData.title;
          });

        //handling double labels
        else {
          const noDoubles = {};
          const doubles = [];
          const doubleObjects = [];

          for (let i = 0; i < lookupField.length; i++){
            if (noDoubles[lookupField[i].title] === true)
              doubles.push(lookupField[i].title);
            else
              noDoubles[lookupField[i].title] = true;
          }

          if (doubles.length > 0){
            lookupField.map(lookupData => {
              doubles.map(double => {
                if (lookupData.title === double)
                  doubleObjects.push(lookupData);
              })
            });

            if (doubleObjects.length > 0){
              doubleObjects.map(double => {
                if (double.id === dbProject)
                  value = double.title + " " + (extraField === "Rebilling" || extraField === "Release Date" ? double.customId : double.code);
              });
            }
          }

          if (!value)
            lookupField.map(lookupData => {
              if (dbProject === lookupData.id)
                value = lookupData.title;
            });
        }
      }

      else
        lookupField.map(lookupData => {
          if (dbProject === lookupData.id)
            value = lookupData.title;
        });
    }

    return value;
  }

  function getDropdownOptions(options, lookupField, extraField){
    if (lookupField && lookupField.length > 0){
      if (extraField) {
        const noDoubles = {};
        const doubles = [];
        for (let i = 0; i < lookupField.length; i++) {
          if (noDoubles[lookupField[i].title] === true)
            doubles.push(lookupField[i].title);
          else
            noDoubles[lookupField[i].title] = true;
        }
  
        if (doubles.length > 0){
          //adding the extra field in double labels 
          lookupField.map(lookupData => {
            doubles.map(double => {
              if (lookupData.title === double){
                const adjustedLabel = lookupData.title + " " + (extraField === "Rebilling" || extraField === "Release Date" ? lookupData.customId : lookupData.code);
                options.push(adjustedLabel);
              }
            })
          });

          //adding no double labels
          lookupField.map(lookupData => {
            doubles.map(double => {
              if (lookupData.title !== double)
                options.push(lookupData.title);
            })
          });
        }

        else
          lookupField.map(lookupData => options.push(lookupData.title));
      }
  
      else
        lookupField.map(lookupData => options.push(lookupData.title));
  
      options.sort();
    }
  }

  function setDropDownOptions(lookUpData) {
    getDropdownOptions(customerOptions, lookUpData.customers);
    getDropdownOptions(digitalsOptions, lookUpData.digitals);
    getDropdownOptions(domainsOptions, lookUpData.domains);
    getDropdownOptions(goalsOptions, lookUpData.goals);
    getDropdownOptions(methodologiesOptions, lookUpData.methodologies);
    getDropdownOptions(naturesOptions, lookUpData.natures);
    getDropdownOptions(investmentOptions, lookUpData.investmentMixes);
    getDropdownOptions(mandatoriesOptions, lookUpData.mandatories);
    getDropdownOptions(prioritiesOptions, lookUpData.priorities);
    getDropdownOptions(prLivesOptions, lookUpData.projectLives);
    getDropdownOptions(prStatusOptions, lookUpData.projectStatus);
    getDropdownOptions(portfolioOptions, lookUpData.portfolioMixes);
    getDropdownOptions(responsibilityOptions, lookUpData.responsibilityCenters);
    getDropdownOptions(prApprovalOptions, lookUpData.projectApprovals);
    getDropdownOptions(prPhaseOptions, lookUpData.projectPhases);
    getDropdownOptions(targetsOptions, lookUpData.targets);
    getDropdownOptions(timingsOptions, lookUpData.timings);
    getDropdownOptions(rebillingsOptions, lookUpData.rebillings, "Rebilling");
    getDropdownOptions(releaseDateOptions, lookUpData.releaseDates, "Release Date");
    getDropdownOptions(controllingAreaOptions, lookUpData.controllingAreas, "Controlling area SAP");

    allDomains = lookUpData.domains;
    allSubDomains = lookUpData.subDomains;
    allCustomers = lookUpData.customers;
    allSubCustomers = lookUpData.subCustomers;
  }

  function getDatePicker() {
    // function to act as a class
    function Datepicker() { }

    // gets called once before the renderer is used
    Datepicker.prototype.init = function (params) {
      // create the cell
      eInput = document.createElement('input');
      eInput.value = params.value;
      eInput.style.height = '100%';
      eInput.style.width = '100%';

      //IE doesn't support <input type="date" />
      if (!window.document.documentMode)
        eInput.type = "date";
    };

    // gets called once when grid ready to insert the element
    Datepicker.prototype.getGui = function () {
      return eInput;
    };

    // focus and select can be done after the gui is attached
    Datepicker.prototype.afterGuiAttached = function () {
      eInput.focus();
      eInput.select();
    };

    // returns the new value after editing
    Datepicker.prototype.getValue = function () {
      return eInput.value;
    };

    // any cleanup we need to be done here
    Datepicker.prototype.destroy = function () {
      // but this example is simple, no cleanup, we could
      // even leave this method out as it's optional
    };

    // if true, then this editor will appear in a popup
    Datepicker.prototype.isPopup = function () {
      // and we could leave this method out also, false is the default
      return false;
    };

    return Datepicker;
  }

  function dateComparator(date1, date2) {
    const date1Number = dateConverter(date1);
    const date2Number = dateConverter(date2);

    if (date1Number === null && date2Number === null)
      return 0;

    if (date1Number === null)
      return -1;

    if (date2Number === null)
      return 1;

    return date1Number - date2Number;
  }

  function dateConverter(date) {
    if (date === undefined || date === null)
      return null;

    const year = date.split(" ")[0].split("/")[2];
    const month = date.split(" ")[0].split("/")[1];
    const day = date.split(" ")[0].split("/")[0];
    const hours = date.split(" ")[1].split(":")[0];
    const minutes = date.split(" ")[1].split(":")[1];
    const seconds = date.split(" ")[1].split(":")[2];

    return new Date(year, month, day, hours, minutes, seconds);
  }

  /*function handlingEstimationValue(params){
    if (
      params.newValue.toLowerCase() === "ktlo" ||
      params.newValue.toLowerCase() === "carry over" ||
      params.newValue.toLowerCase() === "mandatory"
    )
      params.node.setDataValue("estimation", " 0");
    else
      params.node.setDataValue("estimation", params.data.estimation ? params.data.estimation : " 0");

    //when estimation changes value (the command above) its cellStyle function gets triggered but portfolio mix still has the old value and the color doesn't change, that's why a little delay is needed before refreshing estimation's cell with the updated portfolio mix's value
    setTimeout(() => {
      const refreshOption = {
        force: true,
        suppressFlash: true,
        rowNodes: [params.node],
        columns: ["estimation"]
      };

      gridApi.refreshCells(refreshOption);
    }, 100);

    return params.data["portfolio mix"] = params.newValue;
  }*/

  function changingNumericField(params) {
    const field = params.colDef.field;
    
    //0 is considered a null value and valueGetter doesn't get triggered so I turned 0 in a string (that changes for valueGetters but not for UI)
    const value = params.newValue == "0" ? "0 " : Number(params.newValue);
    setNewCellValue(true);

    if (field === "progress") {
      if (String(value).indexOf(".") == -1 && Number(value) >= 0 && Number(value) <= 100)
        return params.data.progress = value;
      else
        return params.data.progress = null;
    }
    else
      return params.data[field] = value;
  }

  function assignBooleanValue(params){
    const field = params.colDef.field;

    //assigning real values
    if (params.newValue === true)
      return params.data[field] = params.newValue;
    else
      return params.data[field] = false;
  }

  function allowOnlyDigits(params){
    if ((Number(params.value) && Number(params.value) <= 2147483647) || params.value == "0 ")
      return params.value;
    else {
      const field = params.colDef.field;
      return params.data[field] = null;
    }
  }

  function currencyFormatter(params) {
    if (params || params == 0) {
      const formatter = new Intl.NumberFormat('en-US', {//it-IT
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });

      if (Number(params.value) || params.value === 0 || params.value == "0 ") {
        const checkValue = params.value == "0 " ? formatter.format(0) : formatter.format(params.value);
        return params.value || params.value === 0 ? checkValue : "";
      }

      //top row sums
      else if (!params.value)
        return Number(params) || params === 0 ? formatter.format(params) : "";

      else
        return "";
    }
  }

  function checkDoubleModifiedProjects(modifiedProjectsId){
    const previousModifiedProjects = modifiedProjects;

    if (modifiedProjects.length > 0){
      modifiedProjectsId.map(currentId => {
        //avoiding to add undefined ids from new projects
        if (typeof currentId == 'number'){
          let isTheSame = false;

          modifiedProjects.map(previousId => {
            if (currentId === previousId)
              isTheSame = true;
          });
    
          if (!isTheSame)
            previousModifiedProjects.push(currentId);
        }
      });
    }

    //first modified project
    else {
      modifiedProjectsId.map(currentId => {
        if (typeof currentId == 'number')
          previousModifiedProjects.push(currentId)
      });
    }
    
    setModifiedProjects(previousModifiedProjects);
  }

  function checkDeletedModifiedProject(removedProjects){
    const removedProjectsId = removedProjects.map(project => project.id);
    const removedDuplicate = modifiedProjects.filter(id => !removedProjectsId.includes(id));
    setModifiedProjects(removedDuplicate);
  }

  function onAddRow(){
    gridApi.deselectAll(); //this avoids errors in applyFilteredSelectedRows
    const unfilterRowsButton = document.querySelector("#unfilterRowsButton");

    if (unfilterRowsButton && !unfilterRowsButton.disabled)
      unfilterRowsButton.click();
    
    const newItem = {};

    if (userInfo && layoutBudget) {
      newItem.year = layoutBudget.observedYear; //field with fixed value
      newItem['it owner'] = userInfo.displayName; //field with fixed value
      newItem.ownerKey = userInfo.externalKey; //field with fixed value
      newItem.timing = "NA"; //field with fixed value
      newItem['project name'] = ""; //not lookup mandatory field
    }

    gridApi.applyTransaction({ add: [newItem] });
    //const res = this.gridApi.applyTransaction({ add: newItem });
    //printResult(res);
    setUnableFilters(true);
  }

  function onCopyRow(selectedProject) {
    gridApi.deselectAll(); //this avoids errors in applyFilteredSelectedRows
    const unfilterRowsButton = document.querySelector("#unfilterRowsButton");

    if (unfilterRowsButton && !unfilterRowsButton.disabled)
      unfilterRowsButton.click();

    const newItem = [{ ...selectedProject }];

    newItem[0].id = undefined;

    if (userInfo && layoutBudget) {
      newItem[0].year = layoutBudget.observedYear;
      newItem[0]["sap initiative"] = null;
      newItem[0]['it owner'] = userInfo.displayName;
      newItem[0].ownerKey = userInfo.externalKey;
      newItem[0].timing = "NA";
      newItem[0].l01 = 0;
      newItem[0]["l01-d1"] = 0;
      newItem[0]["l01-d2"] = 0;
      newItem[0]["l01-d3"] = 0;
      newItem[0].l03 = 0;
      newItem[0]["l03-d1"] = 0;
      newItem[0]["l03-d2"] = 0;
      newItem[0]["l03-d3"] = 0;
      newItem[0].l06 = 0;
      newItem[0]["l06-d1"] = 0;
      newItem[0]["l06-d2"] = 0;
      newItem[0]["l06-d3"] = 0;
      newItem[0].l12 = 0;
      newItem[0]["l12-d1"] = 0;
      newItem[0]["l12-d2"] = 0;
      newItem[0]["l12-d3"] = 0;
      newItem[0]["project ko"] = 0;
      newItem[0]["connected costs"] = 0;
      newItem[0]["h/w connected investments"] = 0;
      newItem[0]["commitment"] = 0;
      newItem[0]["actual"] = 0;
      newItem[0]["project final value"] = 0;
      newItem[0]["estimation"] = 0;
      newItem[0].progress = 0;
      newItem[0]['controlling area sap'] = "";
      newItem[0]['initiative description sap'] = "";
      newItem[0]['created date sap'] = "";
      newItem[0]['profit center sap'] = "";
      newItem[0]['it owner sap'] = "";
      newItem[0]['order type sap'] = "";
      newItem[0]['customer sap'] = "";
    }

    gridApi.applyTransaction({ add: newItem });
    setIsGridChanged(true);
    setInterimFilters(getCurrentFilters());
    gridApi.setFilterModel(null);

    gridApi.forEachNode(node => {
      if (selectedProject.id)
        node.setSelected(node.data.id === selectedProject.id);
    });
  }

  function onRemoveSelected() {
    const selectedData = gridApi.getSelectedRows();

    //removing deleted projects from modified projects array
    if (selectedData.length > 0 && modifiedProjects.length > 0)
      checkDeletedModifiedProject(selectedData);

    const allDeletedProjects = deletedProjects;

    if (selectedData && selectedData.length > 0)
      selectedData.map(unwantedProject => {
        const id = Number(unwantedProject.id) ? unwantedProject.id : 0;
        allDeletedProjects.push(id);
      });

    setDeletedProjects(allDeletedProjects);
    gridApi.applyTransaction({ remove: selectedData });
    updateTopRowSum();

    if (selectedData.length > 0)
      setIsGridChanged(true);

    //const res = gridApi.applyTransaction({ remove: selectedData });
    //printResult(res);

    //if there aren't new projects, the saving of the grid settings is available without clicking save button (when new projects are saved, there aren't new projects in the grid)
    let newProjects = false;
    gridApi.forEachNode(rowNode => {
      if (rowNode && rowNode.data && !rowNode.data.id)
        newProjects = true;
    });

    if (!newProjects){
      applyFilters(interimFilters);
      setUnableFilters(false);
    }
  }

  function onSelectionChanged() {
    const selectedProjects = gridApi.getSelectedRows();
    const nodesProjects = gridApi.getSelectedNodes();
    setSelectedRows(selectedProjects);
    setSelectedNodes(nodesProjects);

    if (selectedProjects && selectedProjects.length > 0) {
      let disableRemoveButton = false;

      function turnIntoNumber(field) {
        //typing 0 doesn't trigger grid changes event because it's considered null (it causes problems with top row sum), that's why I had to use the string "0 " as workaround.
        if (field === "0 ")
          return 0;

        return field;
      }

      selectedProjects.map(project => {
        if (
          (turnIntoNumber(project.l03) +
            turnIntoNumber(project['l03-d1']) +
            turnIntoNumber(project['l03-d2']) +
            turnIntoNumber(project['l03-d3']))
          ||
          (turnIntoNumber(project.l06) +
            turnIntoNumber(project['l06-d1']) +
            turnIntoNumber(project['l06-d2']) +
            turnIntoNumber(project['l06-d3']))
          ||
          (turnIntoNumber(project.l12) +
            turnIntoNumber(project['l12-d1']) +
            turnIntoNumber(project['l12-d2']) +
            turnIntoNumber(project['l12-d3']))
        )
          disableRemoveButton = true;
      });

      if (disableRemoveButton)
        setHasROValue(true);
      else
        setHasROValue(false);
    }
  }

  function exportDataAsExcel() {
    gridApi.exportDataAsExcel({
      skipPinnedTop: true,
      processCellCallback: (params) => {
        if (params.node.rowPinned !== "top") {
          /*if (params.column.colDef.field === "release date")
            return params.column.getColDef().cellRenderer(params);
          if (params.column.getColDef().valueFormatter) {
            return params.column.getColDef().valueFormatter(params);
          }*/
          return params.value;
        }
        //return params.value; after fixing "complex" sum columns
      }
    });
  }

  function getLookupDataId(fieldName, lookupField, cellString, parentId) {
    let value = null;

    //without labels
    if (!cellString || cellString === " "){
      //lookup mandatory fields must have values
      if (
        fieldName === "domain" ||
        fieldName === "customer" ||
        fieldName === "sub domain" ||
        fieldName === "nature" ||
        fieldName === "project approval" ||
        fieldName === "project phase" ||
        fieldName === "portfolio mix" ||
        fieldName === "responsibility center" ||
        fieldName === "target region" ||
        fieldName === "investment mix"
      )
        value = undefined;
    }

    //with labels
    else if (lookupField && lookupField.length > 0) {
      if (
        fieldName === "domain" ||
        fieldName === "customer" ||
        fieldName === "sub domain" ||
        fieldName === "nature" ||
        fieldName === "project approval" ||
        fieldName === "project phase" ||
        fieldName === "portfolio mix" ||
        fieldName === "responsibility center" ||
        fieldName === "target region" ||
        fieldName === "investment mix"
      ){
        if (fieldName === "sub domain"){
          const allSiblings = [];
          //taking all sub domains related to selected domain
          lookupField.map(lookupData => {
            if (lookupData.parentId == parentId)
              allSiblings.push(lookupData);
          });

          //taking selected sub domain
          if (allSiblings.length > 0){
            allSiblings.map(selectedChild => {
              if (selectedChild.title == cellString)
                value = selectedChild.id;
            });
          }
        }
        else {
          lookupField.map(lookupData => {
            if (lookupData.title == cellString)
              value = lookupData.id;
          });
        }

        if (!value)
          value = undefined;
      }

      else if (fieldName === "sub customer"){
        const allSiblings = [];
        //taking all sub customers related to selected customer
        lookupField.map(lookupData => {
          if (lookupData.parentId == parentId)
            allSiblings.push(lookupData);
        });

        //taking selected sub customer
        if (allSiblings.length > 0){
          allSiblings.map(selectedChild => {
            if (selectedChild.title == cellString)
              value = selectedChild.id;
          });
        }

        if (!value)
          value = undefined;
      }

      else if (fieldName === "rebilling" || fieldName === "release date" || fieldName === "controlling area sap") {
        lookupField.map(lookupData => {
          if (lookupData.title + " " + (fieldName === "rebilling" || fieldName === "release date" ? lookupData.customId : lookupData.code) === cellString)
            value = lookupData.id;
        });
  
        if (!value){
          lookupField.map(lookupData => {
            if (lookupData.title == cellString)
              value = lookupData.id;
          });

          if (!value)
            value = undefined;
        }
      }

      else {
        lookupField.map(lookupData => {
          if (lookupData.title == cellString)
            value = lookupData.id;
        });
  
        if (!value)
          value = undefined;
      }
    }

    return value;
  }

  function checkActualChanges(finalProjects){
    const initialData = allProjects.filter(x => modifiedProjects.includes(x.projectId));
    const changedData = finalProjects.filter(x => modifiedProjects.includes(x.projectId));
    const verifiedChangedProjectIds = [];
    
    initialData.map(initialProject => {
      let changedProjectId = null;

      changedData.map(changedProject => {
        if (initialProject.projectId === changedProject.projectId){
          //comparing every single property
          for (let iProperty in initialProject){
            for (let cProperty in changedProject){
              if (iProperty === cProperty){
                if (initialProject[iProperty] !== changedProject[cProperty])
                  changedProjectId = changedProject.projectId;
              }
            }
          }
        }
      });

      if (changedProjectId)
        verifiedChangedProjectIds.push(initialProject.projectId);
    });

    return verifiedChangedProjectIds;
  }

  function clearingFilters(){
    if (gridApi && gridColumnApi) {
      gridApi.deselectAll(); //this avoids errors in applyFilteredSelectedRows
      gridApi.setSortModel(null);
      gridApi.setFilterModel(null);
      setInterimFilters([]);

      const allColumns = [];
      gridColumnApi &&
        gridColumnApi.columnController &&
        gridColumnApi.columnController.columnDefs &&
        gridColumnApi.columnController.columnDefs.map(column => {
          allColumns.push(column.field);
        });

      gridColumnApi.setColumnsPinned(allColumns, null);
    }
  }

  async function addNewView(viewName){
    const leftColumns = gridColumnApi.columnController.displayedLeftColumns;
    const rightColumns = gridColumnApi.columnController.displayedRightColumns;
    const visible = [];
    const leftSettings = [];
    const rightSettings = [];
    const allExistingColumns = [];
    const updatedSettings = [];

    if (leftColumns && leftColumns.length > 0)
      leftColumns.map(leftColumn => leftSettings.push(leftColumn.colDef.field));

    if (rightColumns && rightColumns.length > 0)
      rightColumns.map(rightColumn => rightSettings.push(rightColumn.colDef.field));

    gridColumnApi.columnController.columnDefs.map(column => allExistingColumns.push(column.field));

    gridColumnApi.columnController.allDisplayedColumns.map(column => visible.push(column.colDef.field));

    const hidden = allExistingColumns.filter(x => visible.indexOf(x) === -1);

    updatedSettings[0] = visible;
    updatedSettings[1] = hidden;
    updatedSettings[2] = leftSettings;
    updatedSettings[3] = rightSettings;
    updatedSettings[4] = getCurrentFilters();

    const readySettings = {
      userSettingsId: 0,
      name: viewName,
      isUsed: false,
      userKey: userInfo && userInfo.externalKey,
      gridSettings: JSON.stringify(updatedSettings),
      budgetYearId: layoutBudget.budgetYearId
    };

    return await saveUserSettingsAsync(readySettings);
  }

  function getCurrentFilters(){
    const currentFilters = gridApi.getFilterModel();
    const allFilters = [];

    if (currentFilters){
      for (let columnName in currentFilters){
        if (currentFilters[columnName] && currentFilters[columnName].filterType){
          let filteredColumn = {};
          
          if (currentFilters[columnName].filterType === "set"){
            filteredColumn = {
              name: columnName,
              type: currentFilters[columnName].filterType,
              values: currentFilters[columnName].values
            };
          }
  
          else if (currentFilters[columnName].filterType === "date"){
            if (currentFilters[columnName].operator) {
              filteredColumn = {
                name: columnName,
                operator: currentFilters[columnName].operator,
                type: currentFilters[columnName].filterType,
                condition1: currentFilters[columnName].condition1,
                condition2: currentFilters[columnName].condition2
              };
            }
            //single date 
            else {
              filteredColumn = {
                name: columnName,
                type: currentFilters[columnName].filterType,
                dateFrom: currentFilters[columnName].dateFrom,
                dateTo: currentFilters[columnName].dateTo,
                option: currentFilters[columnName].type
              };
            }
          }
  
          else if (currentFilters[columnName].filterType === "text"){
            if (currentFilters[columnName].operator) {
              filteredColumn = {
                name: columnName,
                operator: currentFilters[columnName].operator,
                type: currentFilters[columnName].filterType,
                condition1: currentFilters[columnName].condition1,
                condition2: currentFilters[columnName].condition2
              };
            }
            //single search 
            else {
              filteredColumn = {
                name: columnName,
                type: currentFilters[columnName].filterType,
                values: currentFilters[columnName].filter,
                option: currentFilters[columnName].type
              };
            }
          }
  
          else if (currentFilters[columnName].filterType === "number"){
            if (currentFilters[columnName].operator) {
              filteredColumn = {
                name: columnName,
                operator: currentFilters[columnName].operator,
                type: currentFilters[columnName].filterType,
                condition1: currentFilters[columnName].condition1,
                condition2: currentFilters[columnName].condition2
              };
            }
            //single search 
            else {
              filteredColumn = {
                name: columnName,
                type: currentFilters[columnName].filterType,
                filter: currentFilters[columnName].filter,
                filterTo: currentFilters[columnName].filterTo,
                option: currentFilters[columnName].type
              };
            }
          }
  
          allFilters.push(filteredColumn);
        }
      }
    }

    return allFilters;
  }

  function applyColumns(blobColumns){
    const visible = blobColumns[0];
    const hidden = blobColumns[1];
    const pinnedLeft = blobColumns[2];
    const pinnedRight = blobColumns[3];

    visible.map(showColumn =>
      gridColumnApi.setColumnVisible(showColumn, true)
    );

    hidden.map(noColumn =>
      gridColumnApi.setColumnVisible(noColumn, false)
    );

    pinnedLeft.map(leftColumn =>
      gridColumnApi.setColumnPinned(leftColumn, 'left')
    );

    pinnedRight.map(rightColumn =>
      gridColumnApi.setColumnPinned(rightColumn, 'right')
    );

    gridColumnApi.moveColumns(visible, 0);
    /*visible.map((column, index) =>
      gridColumnApi.moveColumn(column, index)
    );*/
  }

  function applyFilters(filterColumn){
    const filtersObject = {};

    if (filterColumn && filterColumn.length > 0){
      filterColumn.map(filteredColumn => {
        if (filteredColumn && filteredColumn.type === "set")
          filtersObject[filteredColumn.name] = { type: filteredColumn.type, values: filteredColumn.values };
  
        else if (filteredColumn && filteredColumn.type === "date") {
          if (filteredColumn.operator)
            filtersObject[filteredColumn.name] = { operator: filteredColumn.operator, type: filteredColumn.option, condition1: filteredColumn.condition1, condition2: filteredColumn.condition2 };
          //single date
          else
            filtersObject[filteredColumn.name] = { type: filteredColumn.option, dateFrom: filteredColumn.dateFrom, dateTo: filteredColumn.dateTo };
        }
  
        else if (filteredColumn && filteredColumn.type === "text") {
          if (filteredColumn.operator)
            filtersObject[filteredColumn.name] = { operator: filteredColumn.operator, type: filteredColumn.option, condition1: filteredColumn.condition1, condition2: filteredColumn.condition2 };
          //single search
          else
            filtersObject[filteredColumn.name] = { type: filteredColumn.option, filter: filteredColumn.values };
        }
  
        else if (filteredColumn && filteredColumn.type === "number") {
          if (filteredColumn.operator)
            filtersObject[filteredColumn.name] = { operator: filteredColumn.operator, type: filteredColumn.option, condition1: filteredColumn.condition1, condition2: filteredColumn.condition2 };
          //single search
          else {
            if (filteredColumn.filter || filteredColumn.filter === 0) {
              filtersObject[filteredColumn.name] = { type: filteredColumn.option, filter: filteredColumn.filter, filterTo: filteredColumn.filterTo };
            }
          }
        }
      });
  
      gridApi.setFilterModel(filtersObject);
    }
  }

  function filterSelectedRows(){
    //this command triggers isExternalFilterPresent
    gridApi.onFilterChanged();
    gridApi.deselectAll();
    setAreRowsFiltered(true);
    setSelectedNodes(null);
    setSelectedRows(null);
  }

  //this function doesn't read the state, that's why a let variable and an addEventListener are used as work around
  function applyFilteredSelectedRows(node){
    const unfilterRowsButton = document.querySelector("#unfilterRowsButton");

    //workaround to understand that unfilter button has been clicked
    if (unfilterRowsButton)
      unfilterRowsButton.addEventListener("click", () =>
        previousSelectedFilteredRows = []
      );
    
    //rows have already been filtered
    if (previousSelectedFilteredRows.length > 0){
      //workaround to nullify variable when projects changes year
      if (node.data.year !== previousSelectedFilteredRows[0].year)
        previousSelectedFilteredRows = [];
      else if (gridApi.getSelectedRows().length > 0)
        previousSelectedFilteredRows = gridApi.getSelectedRows();
      
      const isWantedRow = previousSelectedFilteredRows.some(wr => wr.id === node.data.id);
      return isWantedRow;
    }

    else {
      //states can't be read from here
      if (gridApi && gridApi.getSelectedRows().length > 0){
        previousSelectedFilteredRows = gridApi.getSelectedRows();
        const isWantedRow = previousSelectedFilteredRows.some(wr => wr.id === node.data.id);
        return isWantedRow;
      }
  
      else
        return true;
    }
  }

  function saveAllProjectsData() {
    const gridProjects = [];
    const wrongFields = [];
    const sapInitiatives = [];

    gridApi.forEachNode(rowNode => {
      sapInitiatives.push({
        id: rowNode.data.id ? rowNode.data.id : 0,
        projectName: rowNode.data["project name"],
        sap: Number(rowNode.data["sap initiative"])
      });

      let subOwnerKey = null;

      //checking if the pm is related to the right owner
      if (rowNode.data["sub owner"] && projectsTeams && projectsTeams.length > 0){
        let isSubOwner = false;

        projectsTeams.map(team => {
          if (team.projectManagers.length > 0){
            team.projectManagers.map(pm => {
              //existing pm checked in teams
              if (pm.displayName === rowNode.data["sub owner"]){
                isSubOwner = true;

                if (rowNode.data["ownerKey"] === team.owner.userKey)
                  subOwnerKey = pm.userKey;
              }
            });

            //nonexistent pm
            if (subOwnerKey === null && rowNode.data["sub owner"] && rowNode.data["sub owner"] !== " ")
              subOwnerKey = undefined;
          }
        });

        if (isSubOwner && !subOwnerKey)
          subOwnerKey = undefined;
      }

      Object.keys(rowNode.data).map(key => {
        //all not lookup mandatory fields plus sub owner
        if (
          (rowNode.data["sub owner"] && key === 'sub owner' && subOwnerKey === undefined) ||
          (
            key === 'project name' &&
            (!rowNode.data[key] || rowNode.data[key] === " ")
          )
        )
          wrongFields.push({ id: [rowNode.data.id ? rowNode.data.id : 0], field: key });
      });

      //"translating" fields' name for user
      wrongFields.map(x => {
        if (x.field === "project name")
          x.field = "Project Name";
        else if (x.field === "sub owner")
          x.field = "Sub Owner";
      });

      //retrieving lookup id in order to understand if the entered label is correct or not
      const customerId = getLookupDataId("customer", lookUpData.customers, rowNode.data.customer);
      const subCustomerId = getLookupDataId("sub customer", lookUpData.subCustomers, rowNode.data["sub-customer"], customerId);
      const digitalId = getLookupDataId("digital", lookUpData.digitals, rowNode.data.digital);
      const domainId = getLookupDataId("domain", lookUpData.domains, rowNode.data.domain);
      const subDomainId = getLookupDataId("sub domain", lookUpData.subDomains, rowNode.data["sub domain"], domainId);
      const goalId = getLookupDataId("goal", lookUpData.goals, rowNode.data.goal);
      const methodologyId = getLookupDataId("methodology", lookUpData.methodologies, rowNode.data.methodology);
      const natureId = getLookupDataId("nature", lookUpData.natures, rowNode.data.nature);
      const investmentId = getLookupDataId("investment mix", lookUpData.investmentMixes, rowNode.data["investment mix"]);
      const mandatoryId = getLookupDataId("mandatory", lookUpData.mandatories, rowNode.data.mandatory);
      const priorityId = getLookupDataId("priority", lookUpData.priorities, rowNode.data.priority);
      const prLivesId = getLookupDataId("project life", lookUpData.projectLives, rowNode.data["project life"]);
      const prStatusId = getLookupDataId("project status", lookUpData.projectStatus, rowNode.data["project status"]);
      const portfolioId = getLookupDataId("portfolio mix", lookUpData.portfolioMixes, rowNode.data["portfolio mix"]);
      const responsibilityId = getLookupDataId("responsibility center", lookUpData.responsibilityCenters, rowNode.data["responsibility center"]);
      const prApprovalId = getLookupDataId("project approval", lookUpData.projectApprovals, rowNode.data["project approval"]);
      const prPhaseId = getLookupDataId("project phase", lookUpData.projectPhases, rowNode.data["project phase"]);
      const targetId = getLookupDataId("target region", lookUpData.targets, rowNode.data["target region"]);
      const timingId = getLookupDataId("timing", lookUpData.timings, rowNode.data.timing);
      const rebillingId = getLookupDataId("rebilling", lookUpData.rebillings, rowNode.data.rebilling);
      const releaseDateId = getLookupDataId("release date", lookUpData.releaseDates, rowNode.data["release date"]);

      //These conditions are needed to check wrong labels or missing ones (in case of mandatory fields)
      if (customerId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Customer"
        });
      
      if (subCustomerId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Sub Customer"
        });

      if (digitalId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Digital spending"
        });

      if (domainId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Domain"
        });

      if (subDomainId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Sub Domain"
        });

      if (goalId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Goal"
        });

      if (methodologyId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Methodology"
        });

      if (natureId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Nature"
        });

      if (investmentId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Investment mix"
        });

      if (mandatoryId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Mandatory"
        });

      if (priorityId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Priority"
        });

      if (prLivesId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Project Life"
        });

      if (prStatusId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Project Status"
        });
      
      if (portfolioId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Portfolio Mix"
        });

      if (responsibilityId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Responsibility Center"
        });

      if (prApprovalId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Project Approval"
        });

      if (prPhaseId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Project Phase"
        });

      if (targetId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Target region"
        });

      if (timingId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Timing"
        });
      
      if (rebillingId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Rebilling"
        });

      if (releaseDateId === undefined)
        wrongFields.push({
          id: [Number(rowNode.data.id) ? rowNode.data.id : 0],
          field: "Release Date"
        });

      gridProjects.push({
        "projectId": Number(rowNode.data.id) ? rowNode.data.id : 0,
        "ownerKey": rowNode.data.ownerKey,
        "subOwnerKey": subOwnerKey,
        "name": rowNode.data["project name"],
        "businessOwner": rowNode.data["business owner"],
        "sapInitiative": Number(rowNode.data["sap initiative"]) ? Number(rowNode.data["sap initiative"]) : 0,
        "domainId": domainId,
        "subDomainId": subDomainId,
        "targetId": targetId ? targetId : null,
        "customerId": customerId ? customerId : null,
        "subCustomerId": subCustomerId,
        "goalId": goalId ? goalId : null,
        "timingId": timingId ? timingId : null,
        "priorityId": priorityId ? priorityId : null,
        "natureId": natureId ? natureId : null,
        "investmentMixId": investmentId ? investmentId : null,
        "mandatoryId": mandatoryId ? mandatoryId : null,
        "methodologyId": methodologyId ? methodologyId : null,
        "digitalId": digitalId ? digitalId : null,
        "projectLifeId": prLivesId ? prLivesId : null,
        "projectStatusId": prStatusId ? prStatusId : null,
        "portfolioMixId": portfolioId ? portfolioId : null,
        "responsibilityCenterId": responsibilityId ? responsibilityId : null,
        "projectApprovalId": prApprovalId ? prApprovalId : null,
        "projectPhaseId": prPhaseId ? prPhaseId : null,
        "rebillingId": rebillingId ? rebillingId : null,
        "releaseDateId": releaseDateId ? releaseDateId : null,
        "progress": Number(rowNode.data.progress) ? Number(rowNode.data.progress) : 0,
        "estimation": Number(rowNode.data.estimation) ? Number(rowNode.data.estimation) : 0,
        "projectKO": Number(rowNode.data["project ko"]) ? Number(rowNode.data["project ko"]) : 0,
        "connectedCosts": Number(rowNode.data["connected costs"]) ? Number(rowNode.data["connected costs"]) : 0,
        "hardwareConnectedInvestments": Number(rowNode.data["h/w connected investments"]) ? Number(rowNode.data["h/w connected investments"]) : 0,
        "l01": Number(rowNode.data.l01) ? Number(rowNode.data.l01) : 0,
        "l01D1": Number(rowNode.data["l01-d1"]) ? Number(rowNode.data["l01-d1"]) : 0,
        "l01D2": Number(rowNode.data["l01-d2"]) ? Number(rowNode.data["l01-d2"]) : 0,
        "l01D3": Number(rowNode.data["l01-d3"]) ? Number(rowNode.data["l01-d3"]) : 0,
        "l03": Number(rowNode.data.l03) ? Number(rowNode.data.l03) : 0,
        "l03D1": Number(rowNode.data["l03-d1"]) ? Number(rowNode.data["l03-d1"]) : 0,
        "l03D2": Number(rowNode.data["l03-d2"]) ? Number(rowNode.data["l03-d2"]) : 0,
        "l03D3": Number(rowNode.data["l03-d3"]) ? Number(rowNode.data["l03-d3"]) : 0,
        "l06": Number(rowNode.data.l06) ? Number(rowNode.data.l06) : 0,
        "l06D1": Number(rowNode.data["l06-d1"]) ? Number(rowNode.data["l06-d1"]) : 0,
        "l06D2": Number(rowNode.data["l06-d2"]) ? Number(rowNode.data["l06-d2"]) : 0,
        "l06D3": Number(rowNode.data["l06-d3"]) ? Number(rowNode.data["l06-d3"]) : 0,
        "l12": Number(rowNode.data.l12) ? Number(rowNode.data.l12) : 0,
        "l12D1": Number(rowNode.data["l12-d1"]) ? Number(rowNode.data["l12-d1"]) : 0,
        "l12D2": Number(rowNode.data["l12-d2"]) ? Number(rowNode.data["l12-d2"]) : 0,
        "l12D3": Number(rowNode.data["l12-d3"]) ? Number(rowNode.data["l12-d3"]) : 0,
        "committment": Number(rowNode.data.commitment) ? Number(rowNode.data.commitment) : 0,
        "actual": Number(rowNode.data.actual) ? Number(rowNode.data.actual) : 0,
        "notes": rowNode.data.notes,
        "isLocked": rowNode.data.isLocked
      });
    });

    if (sapInitiatives.length > 0){
      const sapDuplicates = [];
      const onlySapInitiatives = sapInitiatives.map(pr => pr.sap);
      onlySapInitiatives.sort();

      onlySapInitiatives.map((sap, sapIndex) => {
        //the second condition avoids duplicated null values
        if (sapIndex !== 0 && sap > 0 && sap === onlySapInitiatives[sapIndex - 1] && !sapDuplicates.some(sd => sd === sap))
          sapDuplicates.push(sap);
      });

      //there cannot be projects with the same sap initiative in a specific year
      if (sapDuplicates.length > 0){
        let errorSameSAP = "The following Sap Initiatives are equal: ";

        sapDuplicates.map((sap, sapIndex) => {
          const wrongProjects = sapInitiatives.filter(pr => pr.sap === sap);

          errorSameSAP += `${sap} (${wrongProjects.map(pr => pr.id + ' "' + pr.projectName + '"').join(", ")})`;

          if (sapDuplicates.length - 1 !== sapIndex)
            errorSameSAP += ", " 
        });

        showErrorMessage(errorSameSAP);
      }

      else {
        //finding duplicate fields
        const uniq = wrongFields
        .map(name => {
          return {
            count: 1,
            name: name.field
          }
        })
        .reduce((a, b) => {
          a[b.name] = (a[b.name] || 0) + b.count;
          return a;
        }, {});

        const duplicates = Object.keys(uniq).filter(a => uniq[a] > 1);

        //gathering ids of duplicate fields
        const gatherDuplicate = [];
        duplicates.map(duplicateField => {
          const allId = [];
          wrongFields.map(pr => {
            if (pr.field === duplicateField)
              allId.push(pr.id);
          });
          gatherDuplicate.push({ field: duplicateField, id: allId });
        });
        
        //removing duplicate fields from original array
        const removedDuplicate = wrongFields.filter(x => !duplicates.includes(x.field));

        //unifying gathered ids of duplicated fields
        const finalWrongFields = gatherDuplicate.concat(removedDuplicate);

        //checking if a modified project has different data since the last loading of the all projects
        const finalModifiedProjects = checkActualChanges(gridProjects);

        const finalProjects = {
          year: Number(layoutBudget.observedYear),
          projects: gridProjects,
          sapProjects: sapProjects,
          deletedProjects: deletedProjects,
          modifiedProjects: finalModifiedProjects,
          saveMode: ProjectSaveMode.MyProjects
        };

        if (deletedProjects.length > 0) {
          if (window.confirm("One or more projects have been deleted.\nDo you want to continue?"))
            sendDataAsync();
        }

        else
          sendDataAsync();

        async function sendDataAsync() {
          if (finalWrongFields.length > 0)
            showErrorMessage(`The following fields are wrong or missing: ${finalWrongFields.map(pr =>
              " " + pr.field + " (" + pr.id.join(', ') + ")"
            )}`);

          else {
            //setRowData(null);
            setIsGridChanged(false);
            setSelectedNodes(null);
            setSelectedRows(null);
            gridApi.deselectAll();
            
            if (getCurrentFilters().length > 0)
              setInterimFilters(getCurrentFilters());

            gridApi.showLoadingOverlay();
            await saveProjectsAsync(finalProjects);
            gridApi.showNoRowsOverlay();
            
            if (document.querySelector(".ag-overlay-no-rows-center"))
              document.querySelector(".ag-overlay-no-rows-center").style.display = "none";
          }
        }
      }
    }
  }

  return (
    <div>
      <div style={{ paddingBottom: '15px' }}>
        {
          isEditable &&
          <>
            <Button
              color="primary"
              size="small"
              variant="contained"
              style={{ marginRight: '15px', fontSize: '11px' }}
              onClick={() => onAddRow()}
            >New project</Button>
            <Button
              color="primary"
              size="small"
              variant="contained"
              style={{ marginRight: '15px', fontSize: '11px' }}
              onClick={() => onRemoveSelected()}
              disabled={
                !selectedRows ||
                selectedRows.length === 0 ||
                hasROValue ||
                selectedRows.some(project => project.isLocked || project.ownerKey !== userInfo.externalKey) ? true : false
              }
            >Remove</Button>
            <Button
              color="primary"
              size="small"
              variant="contained"
              style={{ marginRight: '15px', fontSize: '11px' }}
              onClick={() => onCopyRow(selectedRows[0])}
              disabled={(selectedRows && selectedRows.length === 1 && !selectedRows[0].isLocked) ? false : true}
            >Copy</Button>
            <Button
              color="primary"
              size="small"
              variant="contained"
              style={{ marginRight: '15px', fontSize: '11px' }}
              onClick={() => {
                const isLocking = selectedRows.filter(project => !project.isLocked).length > 0;
                setLockingUnlocking(isLocking);
              }}
              disabled={
                !userInfo ||
                !selectedRows ||
                selectedRows.length === 0 ||
                selectedRows.some(project => project.ownerKey !== userInfo.externalKey) ||
                selectedRows.filter(project => !project.id).length > 0 ||
                (
                  selectedRows.filter(project => project.isLocked).length > 0 &&
                  selectedRows.filter(project => !project.isLocked).length > 0
                )
              }
            >
              {
                !userInfo ||
                !selectedRows ||
                selectedRows.length === 0 ||
                selectedRows.some(project => project.ownerKey !== userInfo.externalKey) ||
                selectedRows.filter(project => !project.id).length > 0 ||
                (
                  selectedRows.filter(project => project.isLocked).length > 0 &&
                  selectedRows.filter(project => !project.isLocked).length > 0
                ) ? "Lock/Unlock" :
                selectedRows.filter(project => project.isLocked).length > 0 ?
                "Unlock" : "Lock"
              }
            </Button>
          </>
        }
        <MilestonesDialog
          selectedProject={selectedRows}
          phaseOptions={lookUpData && lookUpData.milestonePhases}
          statusOptions={lookUpData && lookUpData.milestoneStates}
          saveMilestoneAsync={saveMilestoneAsync}
          deleteMilestoneAsync={deleteMilestoneAsync}
          currentUser={userInfo}
          isUserInRoles={isUserInRoles}
          isEditable={
            isUserInRoles([ApplicationRoles.Owner, ApplicationRoles.ProjectManager]) &&
            readOnlyMode && !readOnlyMode.value &&
            updatedCurrentSession && updatedCurrentSession.isActive ? true : false
          }
          errorMilestone={errorMilestone}
        />
        <LogsDialog
          currentUser={userInfo}
          isUserInRoles={isUserInRoles}
          selectedProject={selectedRows}
          currentSession={updatedCurrentSession}
          readOnlyMode={readOnlyMode}
        />
        <BudgetSessionsDialog selectedProject={selectedRows} />
        <Button
          color="primary"
          size="small"
          variant="contained"
          style={{ marginRight: '15px', fontSize: '11px' }}
          onClick={() => filterSelectedRows()} 
          disabled={!selectedRows || selectedRows.length === 0}
        >Filter selected</Button>
        <Button
          color="primary"
          size="small"
          variant="contained"
          style={{ marginRight: '15px', fontSize: '11px' }}
          onClick={() => {
            setAreRowsFiltered(false);
            gridApi.deselectAll(); //this avoids errors in applyFilteredSelectedRows
            gridApi.onFilterChanged();
          }} 
          disabled={!areRowsFiltered}
          id="unfilterRowsButton"
        >Unfilter selected</Button>
        <Views
          userInfo={userInfo}
          layoutBudget={layoutBudget}
          initialUserViews={userViews}
          updatedView={updatedView}
          addNewView={addNewView}
        />
        <Button
          color="primary"
          size="small"
          variant="contained"
          style={{ marginRight: '15px', fontSize: '11px' }}
          onClick={() => clearingFilters()}
        >Clear filters</Button>
        {
          isEditable &&
          <Button
            color="primary"
            size="small"
            variant="contained"
            style={{ marginRight: '15px', fontSize: '11px' }}
            onClick={() => saveAllProjectsData()}
            disabled={!isGridChanged}
          >Save</Button>
        }
        <Button
          color="primary"
          size="small"
          variant="contained"
          style={{ fontSize: '11px', float: 'right' }}
          onClick={() => exportDataAsExcel()}
        >Export to Excel</Button>
      </div>

      <div className="ag-theme-balham" style={{ height: 'calc(90vh - 85px)', overflowX: 'auto' }}>
        <AgGridReact
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          rowSelection="multiple"
          rowDeselection={true}
          rowData={rowData}
          animateRows={true}
          suppressRowClickSelection={true}
          enableRangeSelection={true}
          enableFillHandle={true}
          sideBar={sideBar}
          onGridReady={params => {
            gridApi = params.api;
            gridColumnApi = params.columnApi;
          }}
          suppressColumnVirtualisation={true}
          multiSortKey={'ctrl'}
          frameworkComponents={frameworkComponents}
          components={components}
          onSelectionChanged={onSelectionChanged}
          isExternalFilterPresent={() => true} //since the button "view selected only" specify the intention of the user to filter the selected rows, no further data checks are needed
          doesExternalFilterPass={applyFilteredSelectedRows}
          onCellValueChanged={params => {
            setIsGridChanged(true);

            //adding modified project to the modified array
            checkDoubleModifiedProjects([params.data.id]);
          }}
          onFilterChanged={updateTopRowSum}
        />
      </div>
    </div>
  );
}

export const MyProjectsPage = () => {
  return (
    <MyProjectsProvider>
      <PageContent />
    </MyProjectsProvider>
  );
}